// extracted by mini-css-extract-plugin
export default {"main":"GetMoney_main__5e+hF","ltr":"GetMoney_ltr__pQFQs","rtl":"GetMoney_rtl__lc1f1","first":"GetMoney_first__90ozq","firstPara":"GetMoney_firstPara__NONUG"};